export const oneDigitValidation = /^\d{0,1}$/;
export const twoDigitValidation = /^\d{0,2}$/;
export const amountValidation = /^\d*$/;
export const numberValidation = /^\d*$/;